import { render, staticRenderFns } from "./ac-dynamic-kanban.vue?vue&type=template&id=019ae5e6&"
import script from "./ac-dynamic-kanban.vue?vue&type=script&lang=js&"
export * from "./ac-dynamic-kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports